var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { CardType } from "../../../../data";
import { SecondaryHeading, HeadingTitle } from "..";
var OutrightHeading = /** @class */ (function (_super) {
    __extends(OutrightHeading, _super);
    function OutrightHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OutrightHeading.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(SecondaryHeading, { key: "subheading-" + this.props.id, cardType: CardType.Regular },
                React.createElement(HeadingTitle, { name: this.props.name, eventsCount: "" })),
            this.props.children));
    };
    return OutrightHeading;
}(React.PureComponent));
export { OutrightHeading };
//# sourceMappingURL=OutrightHeading.js.map